import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { AppLayoutComponent } from './demo/layout/app.layout.component';
import { BaseLayoutComponent } from './layout/components/base-layout/base-layout.component';
import { AuthenticationGuard } from './shared/guards/authentication-guard';
import { routingModuleType } from './shared/enums/module-types';
import { AccessDeniedComponent } from './shared/components/access-denied/access-denied.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled'
};

const routes: Routes = [
    { path: routingModuleType.authentication, data: { breadcrumb: 'Auth' }, loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },
    {
        path: '', component: BaseLayoutComponent,
        children: [
            {
                path: '', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
            },
            { path: routingModuleType.organization, data: { breadcrumb: 'lbl_organizer', icon: 'pi pi-fw pi-microsoft' }, loadChildren: () => import('./organization/organization.module').then(m => m.OrganizationModule) },
            { path: routingModuleType.features, data: { breadcrumb: 'lbl_features', icon: 'pi pi-fw pi-angle-double-up' }, loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule) },
            { path: routingModuleType.interactions, data: { breadcrumb: 'lbl_interactions', icon: 'pi pi-sitemap' }, loadChildren: () => import('./interactions/interactions.module').then(m => m.InteractionsModule) },
            { path: routingModuleType.business, data: { breadcrumb: 'lbl_business', icon: 'pi pi-bitcoin' }, loadChildren: () => import('./business/business.module').then(m => m.BusinessModule) },
            { path: routingModuleType.collaboration, data: { breadcrumb: 'lbl_collaboration', icon: 'pi pi-slack' }, loadChildren: () => import('./collaboration/collaboration.module').then(m => m.CollaborationModule) },
        ],
        canActivate: [AuthenticationGuard],
    },
    { path: 'access-denied', component: AccessDeniedComponent },
    { path: '**', component: NotFoundComponent },

    // demo path
    {
        path: 'layout', component: AppLayoutComponent,
        children: [
            { path: '', loadChildren: () => import('./demo/components/dashboards/dashboards.module').then(m => m.DashboardsModule) },
            { path: 'uikit', data: { breadcrumb: 'UI Kit' }, loadChildren: () => import('./demo/components/uikit/uikit.module').then(m => m.UIkitModule) },
            { path: 'utilities', data: { breadcrumb: 'Utilities' }, loadChildren: () => import('./demo/components/utilities/utilities.module').then(m => m.UtilitiesModule) },
            { path: 'pages', data: { breadcrumb: 'Pages' }, loadChildren: () => import('./demo/components/pages/pages.module').then(m => m.PagesModule) },
            { path: 'profile', data: { breadcrumb: 'User Management' }, loadChildren: () => import('./demo/components/profile/profile.module').then(m => m.ProfileModule) },
            { path: 'documentation', data: { breadcrumb: 'Documentation' }, loadChildren: () => import('./demo/components/documentation/documentation.module').then(m => m.DocumentationModule) },
            { path: 'blocks', data: { breadcrumb: 'Prime Blocks' }, loadChildren: () => import('./demo/components/primeblocks/primeblocks.module').then(m => m.PrimeBlocksModule) },
            { path: 'ecommerce', data: { breadcrumb: 'E-Commerce' }, loadChildren: () => import('./demo/components/ecommerce/ecommerce.module').then(m => m.EcommerceModule) },
            { path: 'apps', data: { breadcrumb: 'Apps' }, loadChildren: () => import('./demo/components/apps/apps.module').then(m => m.AppsModule) }
        ]
    },
    { path: 'auth', data: { breadcrumb: 'Auth' }, loadChildren: () => import('./demo/components/auth/auth.module').then(m => m.AuthModule) },
    { path: 'wizard', data: { breadcrumb: 'Wizard' }, loadChildren: () => import('./demo/components/pages/wizard/wizard.module').then(m => m.WizardModule) },
    { path: 'landing', loadChildren: () => import('./demo/components/landing/landing.module').then(m => m.LandingModule) },
    { path: 'notfound', loadChildren: () => import('./demo/components/notfound/notfound.module').then(m => m.NotfoundModule) },
    { path: 'notfound2', loadChildren: () => import('./demo/components/notfound2/notfound2.module').then(m => m.Notfound2Module) },

];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
